import {disableWindowScroll, enableWindowScroll} from "@spoferan/spoferan-ts-core";

export default {

    emits: ['update:fullscreen'],

    props: {
        fullscreen: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isFullScreen: this.fullscreen,
            initialStylesBeforeFullscreen: {}
        }
    },

    watch: {
        isFullScreen(fullscreen) {
            if (fullscreen) {
                this.openFullScreen();
            } else {
                this.exitFullScreen();
            }
            this.$emit('update:fullscreen', fullscreen)
        },

        fullscreen(fullscreen) {
            this.isFullScreen = fullscreen;
        },
    },

    beforeUnmount() {
        enableWindowScroll();
    },

    methods: {
        openFullScreen() {

            // We can not set height to 100vh since this won't work for mobile devices, see https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
            const styles = {
                zIndex: 100,
                overflow: 'auto',
                width: window.innerWidth + 'px',
                height: window.innerHeight + 'px',
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
            }
            Object.keys(styles).forEach(styleKey => {
                this.initialStylesBeforeFullscreen[styleKey] = this.$el.style[styleKey];
                this.$el.style[styleKey] = styles[styleKey]
            });
            disableWindowScroll();
        },

        exitFullScreen() {
            Object.keys(this.initialStylesBeforeFullscreen).forEach(styleKey => {
                this.$el.style[styleKey] = this.initialStylesBeforeFullscreen[styleKey]
            });
            enableWindowScroll();
        }
    }
}

